export const songs = [
  {"artist":"Billy4, noxsar","name":"ETERNAL CRISIS #200","youtubeId":"fGNeG5e0k8k"},
  {"artist":"Billy4, noxsar","name":"Carnaval","youtubeId":"KtTgUheusJI"},
  {"artist":"Billy4, Elega8Soriat","name":"Forças Armadas","youtubeId":"bQPYZbGzUs0"},
  {"artist":"Billy4, Elega8Soriat","name":"Agonia (OG)","youtubeId":"di2R3SZ65mA"},
  {"artist":"Billy4, DRVGジラ, noxsar, floraa","name":"4 ESPADAS","youtubeId":"GLmH-3eOn6U"},
  {"artist":"Elega8Soriat","name":"Não, Não, Não","youtubeId":"eCyH9q2dP7g"},
  {"artist":"Billy4","name":"i cry real tears","youtubeId":"Ae2r5QWcg3s"},
  {"artist":"Billy4, DRVGジラ","name":"Suicidecity 222","youtubeId":"a7PpdrvVO40"},
  {"artist":"Elega8Soriat","name":"Xeque-Mate","youtubeId":"oOWo9WCnMOE"},
  {"artist":"Billy4, Armand Di Doucer","name":"Be Careful","youtubeId":"fdppSrlxuZc"},
  {"artist":"Billy4, noxsar, DRVGジラ","name":"Cavaleiro 3","youtubeId":"khcvwq5obhw"},
  {"artist":"Elega8Soriat","name":"Mente Dormente","youtubeId":"f3skttc9zkw"},
  {"artist":"Billy4, noxsar","name":"Fantasya","youtubeId":"pkThn_hWWvI"},
  {"artist":"floraa","name":"lucy","youtubeId":"o1-1Eo9hjjY"},
  {"artist":"noxsar, Billy4","name":"LágrimasDePrata永恆的哭泣","youtubeId":"xEIgFn0IBeY"},
  {"artist":"Elega8Soriat","name":"Renegade","youtubeId":"mtBdaf_IdSE"},
  {"artist":"Ino Ikasuki","name":"tell me a lie","youtubeId":"rNbZTPqNAxE"},
  {"artist":"noxsar, Billy4","name":"SikkMob","youtubeId":"nn_5W4uG_2M"},
  {"artist":"Billy4, floraa, noxsar, DRVGジラ","name":"СтеклоBoyz","youtubeId":"7QvxeFZcP4A"},
  {"artist":"Billy4, noxsar, DRVGジラ","name":"KILLIONAIRE","youtubeId":"9HuHxq-YYDY"},
  {"artist":"floraa","name":"bella","youtubeId":"qvOBmTaPzXs"},
  {"artist":"Billy4","name":"Silkroad","youtubeId":"iNe1aWmBZp0"},
  {"artist":"um6ra, DRVGジラ","name":"LOW HEALTH","youtubeId":"mC3_WHEbokE"},
  {"artist":"Billy4","name":"1stAid","youtubeId":"3fpd_hNL0SM"},
  {"artist":"Elega8Soriat","name":"Blurry Face","youtubeId":"xYNkd-RRRFQ"},
  {"artist":"Elega8Soriat","name":"Eu Não Dou A Foda Pra Porra Nenhuma","youtubeId":"VzNg7_rVV_c"},
  {"artist":"Billy4","name":"Harvester","youtubeId":"Ix4vmANYrrY"},
  {"artist":"Billy4","name":"unknown","youtubeId":"HrhiI_25Cus"},
  {"artist":"Billy4, nikita ballista, noxsar","name":"Halloween","youtubeId":"l-jyldgoJXU"},
  {"artist":"Billy4","name":"Zzzombie","youtubeId":"XDLEd0OnwiI"},
  {"artist":"Billy4","name":"Stripper","youtubeId":"Bo1CJzBjyWY"},
  {"artist":"floraa, neria","name":"SPARDA","youtubeId":"CQVLU2koKsI"},
  {"artist":"Billy4","name":"ClassicalCasino","youtubeId":"BvPmqglsczs"},
  {"artist":"Elega8Soriat","name":"Veneno","youtubeId":"0uPL1P4njWk"},
  {"artist":"Elega8Soriat","name":"Nas Nove Horas A Bruxa Acorda","youtubeId":"KITaTAtWaP8"},
  {"artist":"Billy4","name":"Fakest Person in the World","youtubeId":"tKkTSrxMlak"},
  {"artist":"Billy4","name":"Aids Theater","youtubeId":"cxXtWOgEpmM"},
  {"artist":"Billy4","name":"Liquid","youtubeId":"AgLhhV9oLUo"},
  {"artist":"floraa","name":"BLOSSOM","youtubeId":"ZT5yUeyMsoI"},
  {"artist":"Billy4","name":"Forever Alone","youtubeId":"YTSC8P1qXFw"},
  {"artist":"Elega8Soriat","name":"Espadas","youtubeId":"SPwyQnsUTrE"},
  {"artist":"Billy4","name":"Lendário","youtubeId":"LjMLtIJlftU"},
  {"artist":"Billy4","name":"Agonia","youtubeId":"gxe-CFk9LsY"},
  {"artist":"Billy4","name":"Hino Imortal","youtubeId":"f0jYHv46mWI"},
  {"artist":"Billy4","name":"Red Man Floresta","youtubeId":"7oVmik_veeU"},
  {"artist":"Billy4","name":"Cavaleiro","youtubeId":"pvTc-VZ0el8"},
  {"artist":"Billy4","name":"Anjo Com Nikes","youtubeId":"aUU2MFgp1vY"},
  {"artist":"Billy4","name":"cavaleiro 2","youtubeId":"8M6Mqd5-4ko"},
  {"artist":"Billy4","name":"Sangue+","youtubeId":"QBvf_wH-nPo"},
  {"artist":"Billy4","name":"Nokia 3310","youtubeId":"9sMRTGaBwQk"},
  {"artist":"Billy4","name":"INEM","youtubeId":"ulaJUsvyweg"},
  {"artist":"Billy4","name":"mata-me se tu quiseres","youtubeId":"L2IKCFhEGLs"},
  {"artist":"Billy4, Elega8Soriat","name":"Sangrando #5BW #E8S","youtubeId":"lqZimQGKswI"},
  {"artist":"Billy4","name":"Sora Flower #truelove","youtubeId":"kvaVvdI_3-w"},
  {"artist":"noxsar, Billy4, floraa","name":"Ultima9","youtubeId":"WKtNPKrMoUQ"},
  {"artist":"Billy4","name":"feel like isaac","youtubeId":"Wwdq6MUoHp0"},
  {"artist":"Billy4","name":"Afraid of the dark","youtubeId":"wYEh-5ou1B8"},
  {"artist":"Billy4","name":"Mahjong Garden","youtubeId":"TaIre30AgW4"},
  {"artist":"Billy4, Armand di doucer","name":"Library day(Zzz) captcha solver: masked","youtubeId":"UAcQOE9ICBE"},
  {"artist":"Billy4","name":"Symphony No. 4, Op: 1337, in G-sharp Major","youtubeId":"fBAcJRf38i8"},
  {"artist":"Billy4","name":"#Stickman","youtubeId":"6fYWAoXvZt0"},
  {"artist":"Billy4","name":"Cry","youtubeId":"QgmMPe6TJ8o"},
  {"artist":"Billy4","name":"Money Castle","youtubeId":"PSss_GUkQzU"},
  {"artist":"Billy4","name":"Esquema Social","youtubeId":"sfiqJzoY1eU"},
  {"artist":"Billy4","name":"Kappa","youtubeId":"_xCbDsLFXyQ"},
  {"artist":"Billy4","name":"iWish4","youtubeId":"ykDV4VdQ0Xw"},
  {"artist":"Billy4","name":"Circo","youtubeId":"2UYAPcf5fjk"},
  {"artist":"Billy4","name":"Thought Bubble 2","youtubeId":"UF3bJ3LPLx0"},
  {"artist":"Billy4","name":"Piano","youtubeId":"uJukHVvfkT4"},
  {"artist":"Billy4","name":"Vanilla","youtubeId":"VfvgL2lvq5g"},
  {"artist":"Billy4","name":"Brick","youtubeId":"0kdBMXLd_Z8"},
  {"artist":"Billy4, Armand di doucer","name":"хoлog iN THe DaRK OUTSiDE, game for life","youtubeId":"KjsloX7bRI4"},
  {"artist":"Billy4","name":"Sweet Dreams","youtubeId":"aKZkL_eWD7g"},
  {"artist":"Billy4, 南部犯罪份子","name":"Toy","youtubeId":"V86lkl6EwgE"},
  {"artist":"Billy4, 南部犯罪份子","name":"Fish","youtubeId":"8CG5TRttE9s"},
  {"artist":"Billy4","name":"evian prince","youtubeId":"JjIPwAIksfI"},
  {"artist":"Billy4","name":"It's a beautiful day","youtubeId":"CmvRRsnfMxk"},
  {"artist":"Billy4","name":"Die Galerie","youtubeId":"-_90zETNIxE"},
  {"artist":"Billy4","name":"Sniper School","youtubeId":"zP5vK3mvGKs"},
  {"artist":"Billy4","name":"Nobodywannalisten2me","youtubeId":"9TpW3zZOzT4"},
  {"artist":"Billy4","name":"Thought Bubble","youtubeId":"keZS0QfAIyo"},
  {"artist":"Billy4, Elega8Soriat","name":"Armistice Intro","youtubeId":"Xqaw0-L-sBQ"},
  {"artist":"Billy4, Elega8Soriat","name":"Fetiches & Disfarçes","youtubeId":"P5ovwpxzXe0"},
  {"artist":"Billy4, Elega8Soriat","name":"Forças Armadas","youtubeId":"ybHCHuhPnR8"},
  {"artist":"Billy4, Elega8Soriat","name":"Grim Life","youtubeId":"24tX2nf4MTI"},
  {"artist":"Billy4, Elega8Soriat","name":"Redman Floresta (REMIX)","youtubeId":"l7fSw5SZhv0"},
  {"artist":"Billy4, Elega8Soriat","name":"Glasscity SPD","youtubeId":"o0DozALRe_M"},
  {"artist":"Billy4, Elega8Soriat","name":"Suicide Crow","youtubeId":"cbGB9E8ZHCQ"},
  {"artist":"Billy4, Elega8Soriat","name":"Blur Interlude","youtubeId":"__Q9VKjUKxk"},
  {"artist":"Billy4, Elega8Soriat","name":"4VRPAIN (REMIX)","youtubeId":"DbbCFbnLXNw"},
  {"artist":"Billy4, Elega8Soriat","name":"Last Kiss","youtubeId":"DSlFQp-u_d8"},
  {"artist":"Billy4, Elega8Soriat","name":"Ghost Man","youtubeId":"XoSc9pEnxXw"},
  {"artist":"Billy4, Elega8Soriat, shaarksz","name":"Shy Guy","youtubeId":"73eoklwc4dw"},
  {"artist":"Billy4, Elega8Soriat","name":"Evil Drug","youtubeId":"JJaYqYirT_8"},
  {"artist":"Billy4, Elega8Soriat","name":"Nothing2u","youtubeId":"MpoquiJZqpI"},
  {"artist":"Billy4, Elega8Soriat","name":"Redcross Sombra","youtubeId":"rG3HMH42lD0"},
  {"artist":"Billy4, Elega8Soriat","name":"MOTOSERRA","youtubeId":"yIhW5X9edes"},
  {"artist":"Billy4, Elega8Soriat, noxsar","name":"Autópsia","youtubeId":"Vn8PmfYmvjY"},
  {"artist":"Billy4, Elega8Soriat","name":"AGONIA (REMIX)","youtubeId":"yaoh8jsMkRE"},
  {"artist":"Billy4, Elega8Soriat","name":"Eternal End","youtubeId":"qveW5a-QOvM"},
  {"artist":"Billy4, noxsar, DRVGジラ, floraa","name":"Santander Totta","youtubeId":"owqcW4YlKYk"},
  {"artist":"Billy4, noxsar, DRVGジラ","name":"Sirurgya","youtubeId":"uRaOskAk9hE"},
  {"artist":"Billy4, noxsar, DRVGジラ, Elega8Soriat","name":"BloodKingdom","youtubeId":"jcYB64WbZE4"},
  {"artist":"Billy4, noxsar, DRVGジラ, floraa","name":"A.S.M.A.","youtubeId":"UhLl9AkSWr0"},
  {"artist":"Billy4, noxsar, DRVGジラ","name":"Sicka3z","youtubeId":"OaeWMKhIuE8"},
  {"artist":"Billy4, noxsar, DRVGジラ","name":"FaceTime NDA","youtubeId":"gEw_fCi8wYM"},
  {"artist":"Billy4, noxsar, DRVGジラ, floraa","name":"White Flag","youtubeId":"uUMYp0qh7aQ"},
  {"artist":"Billy4","name":"Sanitarium","youtubeId":"IZSPHQChzmw"},
  {"artist":"Billy4","name":"Wet Gold","youtubeId":"fKX5XSmC_VE"},
  {"artist":"Billy4","name":"Sw4t","youtubeId":"zwH9k5tJVC8"},
  {"artist":"Billy4","name":"S&S","youtubeId":"EBbyFRhUAxw"},
  {"artist":"Billy4, noxsar, DRVGジラ","name":"Monte Cristo","youtubeId":"Vk9o0f4o-pE"},
  {"artist":"Billy4","name":"b.l.a.m.e","youtubeId":"weQ4KDbQm8o"},
  {"artist":"Billy4","name":".44 Crusader","youtubeId":"5_aA9voAOzc"},
  {"artist":"Billy4","name":"GoEz","youtubeId":"c4YNfAbHXwU"},
  {"artist":"Billy4","name":"Secret Room","youtubeId":"0f77WEaQ6zI"},
  {"artist":"Billy4","name":"False Protection","youtubeId":"vI1MY0Var8I"},
  {"artist":"Billy4","name":"Lifewish","youtubeId":"wciuBitB4uA"},
  {"artist":"Billy4","name":"Nevermore","youtubeId":"bbbrWd2jtmo"},
  {"artist":"Billy4","name":"Klaymen","youtubeId":"XbV08BRniw4"},
  {"artist":"Billy4","name":"IceGatePark","youtubeId":"rCrhdwte94w"},
  {"artist":"Billy4, DRVGジラ","name":"Death By Auto","youtubeId":"flBWJenkRFE"},
  {"artist":"Billy4","name":"Masquerade Vampira","youtubeId":"t4Ut-HH_ew4"},
  {"artist":"Billy4","name":"Patient 0","youtubeId":"J1cZVmNB2Mc"},
  {"artist":"Billy4","name":"Monster","youtubeId":"DjNT7UC13sg"},
  {"artist":"Billy4","name":"Plastic Bag","youtubeId":"HFzRciSeOxo"},
  {"artist":"Billy4","name":"Myst","youtubeId":"UOVS4WxILaE"},
  {"artist":"Billy4","name":"What it's like","youtubeId":"DhGFzjs4OX0"},
  {"artist":"Billy4","name":"The Night of","youtubeId":"zSfjPqU2SG0"},
  {"artist":"Billy4","name":"Puddle Cat","youtubeId":"QBmqKwTI6aY"},
  {"artist":"Billy4","name":"Email","youtubeId":"2GeU8cGSGMA"},
  {"artist":"Billy4","name":"Golden Dragon","youtubeId":"UU0nKFFO3GI"},
  {"artist":"Billy4","name":"Burn Victim","youtubeId":"HRjsvH2FTKc"},
  {"artist":"Billy4","name":"Elephant","youtubeId":"QGD5TxsWNYU"},
  {"artist":"Billy4","name":"Result","youtubeId":"MOV6gBu1hZg"},
  {"artist":"Billy4","name":"Give up","youtubeId":"V5pCNU1QsbY"},
  {"artist":"Billy4","name":"Pesadelo","youtubeId":"zW7-2a2pnjo"},
  {"artist":"floraa","name":"ego","youtubeId":"fLlvJTVRxjw"},
  {"artist":"floraa","name":"snowing","youtubeId":"PrVkGzYu7K4"},
  {"artist":"floraa","name":"pride and prejudice","youtubeId":"3pvL3Fco1R0"},
  {"artist":"floraa","name":"miharas","youtubeId":"IAwpgA2IFXk"},
  {"artist":"floraa","name":"makeup","youtubeId":"CiFUhJDzItw"},
  {"artist":"floraa","name":"scars","youtubeId":"7LRXs4flqew"},
  {"artist":"floraa","name":"sina","youtubeId":"qm_wD386Mt4"},
  {"artist":"floraa","name":"EMINEM","youtubeId":"z7JP69Q_AMA"},
  {"artist":"floraa","name":"chaga","youtubeId":"n6ZUOy09XRI"},
  {"artist":"floraa","name":"hysteria","youtubeId":"Lngb6CEf9pk"},
  {"artist":"floraa, miyel","name":"plastic tree","youtubeId":"BoQImQSQGEs"},
  {"artist":"floraa","name":"iKON","youtubeId":"2Hayp8maQWA"},
  {"artist":"floraa","name":"REHAB","youtubeId":"iWIneACd2MY"},
  {"artist":"floraa","name":"YASUYUKI","youtubeId":"vFvlK7JxfLo"},
  {"artist":"floraa","name":"PARIS","youtubeId":"6gzs6XN1oW0"},
  {"artist":"DRVGジラ","name":"OHANA","youtubeId":"0T8JiyY7JCk"},
  {"artist":"um6ra","name":"Club","youtubeId":"BRbQWLqu4EY"},
  {"artist":"um6ra","name":"Sick","youtubeId":"_OwsBISe0MA"},
  {"artist":"um6ra","name":"Trap Citizen","youtubeId":"ltVKddYuvTM"},
  {"artist":"um6ra","name":"Tuner","youtubeId":"U2iPJcoA9ew"},
  {"artist":"um6ra","name":"Commercial Trees","youtubeId":"94eTGeIhKmo"},
  {"artist":"um6ra","name":"Tired Stars","youtubeId":"nOPv240r0QI"},
  {"artist":"um6ra, floraa","name":"Mortal Srike","youtubeId":"476YGzhA_MA"},
  {"artist":"um6ra","name":"AWP","youtubeId":"FyPzQkZu5XU"},
  {"artist":"um6ra, numiall","name":"Spakoina","youtubeId":"IeI4yutP6mw"},
  {"artist":"um6ra","name":"Get Outt","youtubeId":"kdHxDW45_a0"},
  {"artist":"um6ra","name":"Трудный возраст (Trudnyj vozrast)","youtubeId":"0B4WPEc7HXY"},
]

